import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PortalLayout from '../../components/portal/PortalLayout';
import ClientAuthGuard from '../../components/portal/ClientAuthGuard';
import BookingStep1 from '../../components/portal/BookingStep1';
import BookingTimePage from './BookingTimePage';
import BookingReviewPage from './BookingReviewPage';
import BookingSuccessPage from './BookingSuccessPage';
import MyBookingsPage from './MyBookingsPage';
import MyProfilePage from './MyProfilePage';
import NotificationsPage from './NotificationsPage';

const PortalWrapper = () => {
  return (
    <ClientAuthGuard>
      <PortalLayout>
        <Routes>
          <Route path="/" element={<Navigate to="/app/book" replace />} />
          <Route path="/book" element={<BookingStep1 />} />
          <Route path="/book/time" element={<BookingTimePage />} />
          <Route path="/book/review" element={<BookingReviewPage />} />
          <Route path="/book/success" element={<BookingSuccessPage />} />
          <Route path="/bookings" element={<MyBookingsPage />} />
          <Route path="/profile" element={<MyProfilePage />} />
          <Route path="/notifications" element={<NotificationsPage />} />
        </Routes>
      </PortalLayout>
    </ClientAuthGuard>
  );
};

export default PortalWrapper;
